import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const BuyRocketDexscreener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Buy Rocket Dexscreener 🚀 - Buy Dexscreener Reaction | Dexreaction</title>
        <meta name="description" content="Buy Dexscreener rockets 🚀 - the #1 bullish reaction! Buy Dexscreener reaction to show momentum for your token. Starting at $0.05/rocket. Fastest delivery, natural patterns. Get 10% bonus rockets free!" />
        <meta name="keywords" content="buy rocket dexscreener, buy dexscreener reaction, buy dexscreener rockets, buy dexscreener fire, buy dexscreener poop, dexreactions, dexscreener rockets, buy dexscreener rockets, rocket dexmoji, bullish dexscreener, dexscreener rocket emoji, telegram rocket bot, dexscreener trending rockets, cheap dexscreener reactions" />
        <link rel="canonical" href="https://dexreaction.com/buy-rocket-dexscreener" />
        <meta property="og:title" content="Buy Dexscreener Rockets 🚀 - Buy Dexscreener Reaction | Dexreaction" />
        <meta property="og:description" content="Buy Dexscreener rockets from $0.05! Show bullish momentum. Instant delivery, natural patterns!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:image" content="https://dexreaction.com/logo-light.png" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-orange-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-orange-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button onClick={() => navigate('/')} className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                Get Started
              </button>
            </div>
          </div>
        </nav>

        {/* Hero - Rocket Focused */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <div className="text-9xl mb-6 animate-bounce">🚀</div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-orange-400 via-red-400 to-yellow-400 bg-clip-text text-transparent">
              Buy Rocket Reactions
            </h1>
            <p className="text-2xl text-gray-300 mb-4 max-w-3xl mx-auto">
              The #1 Most Popular DexScreener Reaction for Bullish Tokens
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
              Show strong upward momentum and community confidence with authentic Rocket 🚀 reactions. Perfect for trending tokens and new launches.
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105 inline-flex items-center gap-2"
            >
              🚀 Buy Rocket Reactions
            </button>
          </div>
        </section>

        {/* Why Rocket */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Why Choose Rocket 🚀 Reactions?
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { icon: '📊', title: 'Most Popular', desc: 'Rocket is the #1 most used reaction on DexScreener, representing bullish sentiment' },
                { icon: '🎯', title: 'Perfect for Launches', desc: 'Ideal for new token launches and trending moments to show strong momentum' },
                { icon: '💪', title: 'Builds Confidence', desc: 'High rocket counts attract more investors and build community confidence' }
              ].map((item, idx) => (
                <div key={idx} className="bg-gradient-to-br from-orange-900/30 to-red-900/30 border border-orange-500/20 rounded-xl p-6 text-center">
                  <div className="text-5xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                  <p className="text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Rocket Benefits */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold mb-6">
                  Rocket Reaction Benefits
                </h2>
                <div className="space-y-4">
                  {[
                    'Signal bullish momentum to potential investors',
                    'Increase visibility in trending sections',
                    'Build social proof and credibility',
                    'Attract more organic engagement',
                    'Show strong community support',
                    'Perfect for pump campaigns'
                  ].map((benefit, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <div className="text-2xl">🚀</div>
                      <p className="text-lg text-gray-300">{benefit}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-gradient-to-br from-orange-500/10 to-red-500/10 border-2 border-orange-500/30 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-6 text-center">Rocket Package Pricing</h3>
                <div className="space-y-4">
                  {[
                    { qty: 500, price: 25, total: 600 },
                    { qty: 1000, price: 50, total: 1200 },
                    { qty: 1500, price: 75, total: 1800 },
                    { qty: 2000, price: 100, total: 2400 }
                  ].map((pkg) => (
                    <div key={pkg.qty} className="bg-slate-900/50 border border-orange-500/30 rounded-lg p-4 flex justify-between items-center">
                      <div>
                        <div className="font-bold text-lg">{pkg.qty} 🚀 Rockets</div>
                        <div className="text-sm text-green-400">Get {pkg.total} total (+20%)</div>
                      </div>
                      <div className="text-right">
                        <div className="text-2xl font-bold text-orange-400">${pkg.price}</div>
                        <div className="text-xs text-gray-400">$0.05/reaction</div>
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => navigate('/')}
                  className="w-full mt-6 bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white py-4 rounded-lg font-bold text-lg transition-all"
                >
                  Buy Rockets Now
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Comparison */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">
              When to Use Rocket vs Other Reactions
            </h2>
            <div className="space-y-4">
              {[
                { emoji: '🚀', name: 'Rocket', use: 'Bullish launches, trending tokens, upward momentum', best: 'New launches & pumps' },
                { emoji: '🔥', name: 'Fire', use: 'High volume, viral moments, hot tokens', best: 'Trending & viral' },
                { emoji: '⭐', name: 'Favorite', use: 'Community support, long-term holds', best: 'Community tokens' }
              ].map((item, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-orange-500/20 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="text-4xl">{item.emoji}</div>
                    <div className="flex-grow">
                      <h3 className="text-xl font-bold mb-2">{item.name}</h3>
                      <p className="text-gray-400 mb-2">Use for: {item.use}</p>
                      <p className="text-sm text-orange-400">Best for: {item.best}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Social Proof */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-12">Trusted by Successful Token Projects</h2>
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              {[
                { number: '500K+', label: 'Rocket Reactions Delivered' },
                { number: '300+', label: 'Tokens Boosted' },
                { number: '98%', label: 'Satisfaction Rate' }
              ].map((stat, idx) => (
                <div key={idx} className="bg-slate-800/50 rounded-xl p-6">
                  <div className="text-4xl font-bold text-orange-400 mb-2">{stat.number}</div>
                  <div className="text-gray-400">{stat.label}</div>
                </div>
              ))}
            </div>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              Start Your Rocket Campaign 🚀
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-orange-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-orange-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-orange-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-orange-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BuyRocketDexscreener;
